import React, { useState } from "react";
import { createLogin } from "../../../service/AdminLoginService";
import { useToast } from "../../toast/ToastProvider";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "react-feather";
import { validateEmail } from "../../../config/function";
import { Form } from "react-bootstrap";

const AdminLogin = ({ onLogin }) => {
  const toast = useToast()
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // const [showHint, setShowHint] = useState({ email: '' });
  const navigate = useNavigate();





  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!validateEmail(email)) {
    //           setShowHint(prev => ({ ...prev, email: "Please enter a valid email address" }));
    //           return;
    //       } else {
    //           setShowHint(prev => ({ ...prev, email: "" }));
    //       }


    try {
      const response = await createLogin({ email, password });

      toast(response.message || "Login successful 🎉");
      onLogin(email)
      navigate("/admin/dashboard");
      setEmail("");
      setPassword("");
    } catch (error) {
      if (error.response && error.response.data) {
        const errData = error.response.data;
        const errMsg = errData.message || errData.error || "Login failed";
        toast(errMsg, "ERROR");
      } else {
        toast("Network or server error", "ERROR");
      }
      console.error("Login error:", error);
    }
  };



  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{
        background: "linear-gradient(to right, #667eea, #764ba2)",
      }}
    >
      <div
        className="card shadow-lg p-4"
        style={{
          width: "100%",
          maxWidth: "400px",
          borderRadius: "15px",
        }}
      >
        <h3 className="text-center mb-4" style={{ color: "#333" }}>
          Welcome Back 👋
        </h3>
        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="mb-3">
            <label className="form-label fw-bold">UserId:</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your UserId"
              value={email}
              onChange={(e) => {
                const value = e.target.value;
                setEmail(value);
                //  if(!value){
                //   setShowHint((prev)=>({...prev, email:''}));
                //  }else if(!validateEmail(value)){
                //   setShowHint((prev)=>({...prev, email:'please enter a valid email address'}))
                //  }else{
                //   setShowHint((prev)=>({...prev,email:''}))
                //  }
              }

              }
              required
            />
            {/* {showHint && (
              <Form.Text className="text-danger">
                {showHint.email}
              </Form.Text>
            )} */}
          </div>

          {/* Password */}
          <div className="mb-3">
            <label className="form-label fw-bold" style={{ position: 'relative' }}>Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '40px',
                top: '65%',
                cursor: 'pointer',
              }}>{
                showPassword ? <EyeOff /> : <Eye />}</span>
          </div>

          {/* Button */}
          <div className="d-grid">
            <button
              type="submit"
              className="btn btn-primary"
              style={{
                backgroundColor: "#667eea",
                borderColor: "#667eea",
                borderRadius: "10px",
              }}
            >
              Login
            </button>
          </div>
        </form>

        {/* 
        <p className="text-center mt-3 mb-0" style={{ fontSize: "14px" }}>
          Don’t have an account?{" "}
          <a href="/signup" className="fw-bold" style={{ color: "#667eea" }}>
            Sign up
          </a>
        </p> */}
      </div>
    </div>
  );
}
export default AdminLogin 